import types from 'constants/UserConstants';
import Immutable from 'immutable';
import moment from 'moment';

const initialState = Immutable.fromJS({
	userList: [],
	selected: 0,
	year: moment().format("YYYY"),
	month: moment().format("MM"),
	selectedUserInfo: {
		dailySalary: "-",
		salaryAdjust: {},
		shiftRecord: {}
	},
  positionList: [],
	loadingUserData: false,
});

export default function(state = initialState, action) {
	switch (action.type) {
		case types.RESET_USER_LIST:
			return state.setIn(['userList'], Immutable.fromJS(action.userList));
		
		case types.APPEND_USER_LIST:
			return state.updateIn(['userList'], list => list.push(Immutable.fromJS({
				uid: action.uid,
				name: action.name,
				role: action.role,
				status: action.status
      })))

		case types.UPDATE_USER_LIST:
			let idx = state.get('userList').findIndex(user => user.get('uid') === action.uid)
			return state.setIn(['userList', idx, 'name'], action.name)
									.setIn(['userList', idx, 'role'], action.role)
									.setIn(['userList', idx, 'status'], action.status)

		case types.SWITCH_SELECTED_USER:
			return state.set('selected', action.uid);

		case types.SWITCH_YEAR:
			return state.set('year', action.year);

		case types.SWITCH_MONTH:
			return state.set('month', action.month);

		case types.UPDATE_DAILY_SALARY:
			return state.setIn(
					['selectedUserInfo', 'dailySalary'],
					action.dailySalary
				);

		case types.UPDATE_SALARY_ADJUST:
			return state.setIn(
					['selectedUserInfo', 'salaryAdjust'], Immutable.fromJS(action.salaryAdjust)
				)

		case types.UPDATE_SALARY_ADJUST_DETAIL:
			let {id , amount, typeID, note} = action;

			return state.mergeDeep({
				selectedUserInfo: {
					salaryAdjust: {
						[id]: {
								amount: parseInt(amount, 10),
								typeID: typeID,
								note: note,
							}
						}
					}
				}
			)

    case types.REMOVE_SALARY_ADJUST:
      return state.deleteIn(['selectedUserInfo', 'salaryAdjust', action.id])

		case types.UPDATE_SHIFT_RECORD:
			return state.setIn(
					['selectedUserInfo', 'shiftRecord'], Immutable.fromJS(action.shiftRecord)
				)

    case types.CONFIRM_RECORD:
      let {confirm} = action;
      return state.mergeDeep({
        selectedUserInfo: {
          shiftRecord: {
            [action.id]: {
              confirmAt: (confirm? moment().format("YYYY-MM-DD") : null)
            }
          }
        }
      })

    case types.REFRESH_POSITION_LIST:
      return state.set('positionList', Immutable.fromJS(action.positions))

    case types.UPDATE_POSITION_NAME:
      return state.setIn(['positionList', state.get('positionList').findIndex((type) => type.get('id') === action.id), 'name'],
        action.name
			)
			
		case types.UPDATE_POSITION_TYPE:
			return state.setIn(['positionList', state.get('positionList').findIndex((type) => type.get('id') === action.id), 'type'],
				action.toType
			)

    case types.DELETE_POSITION:
      return state.deleteIn(['positionList', state.get('positionList').findIndex((type) => type.get('id') === action.id)])

    case types.ADD_POSITION:
      return state.updateIn(['positionList'], list => list.push(Immutable.fromJS({
        id: action.id,
				name: action.name,
				type: 0
      })))

		case types.START_LOADING_USER_DATA:
			return state.set('loadingUserData', true)
			
		case types.FINISH_LOADING_USER_DATA:
			return state.set('loadingUserData', false)

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/User.js